module.exports = __webpack_public_path__ + "static/media/firm_icon.474da93f.svg";